<template>
  <div class="bg-white overflow-hidden shadow rounded-lg">
    <OrderCustomerEditSlideover
      title="Edit Order Customer Info"
      :visible="slideoverVisible"
      v-on:toggle-slideover="toggleSlideover"
      v-bind:order="order"
    />
    <tabs>

      <!-- Shipping Tab -->
      <tab title="Shipping" class="px-4 py-4">

        <div class="flex justify-between items-center flex-wrap sm:flex-no-wrap object-top">
          <div class="flex font-bold text-lg">
            {{ order.ShipName }}
          </div>
          <div class="flex-shrink-0 flex">
            <ActionsMenu v-if="canShowActions">
              <ActionsItem @click="toggleSlideover" >
                Edit Address
              </ActionsItem>
              <ActionsItem @click="validateAddress" :disabled="validating">
                Validate Address
              </ActionsItem>
            </ActionsMenu>
          </div>
        </div>

        <div>{{ order.ShipAddress }}</div>
        <div class="flex flex-1 flex-row" :title="order.ShipAddress2">{{ address2(order.ShipAddress2) }}</div>
        <div class="flex flex-1 flex-row">
          <div class="mr-2">{{ order.ShipCity }},</div>
          <div class="mr-2">{{ order.ShipState }}</div>
          <div>{{ order.ShipZip }}</div>
        </div>
        <div>{{ order.ShipCountry }}</div>
        <div>{{ order.ShipPhone }}</div>
        <div>{{ order.Email }}</div>

        <OrderAddressValidationStatus
          :validating="validating"
          :validationStatus="validationStatus"
          :error="error"
        />

      </tab>

      <!-- Billing Tab -->
      <tab title="Billing">
        <div class="px-4 py-4 overflow-y-scroll">
          <div class="justify-left">
            <div class="font-bold text-lg">{{ order.Name }}</div>
            <div>{{ order.Address }}</div>
            <div class="flex flex-1 flex-row" :title="order.Address2">{{ address2(order.Address2) }}</div>
            <div class="flex flex-1 flex-row">
              <div class="mr-2">{{ order.City }},</div>
              <div class="mr-2">{{ order.State }}</div>
              <div>{{ order.Zip }}</div>
            </div>
            <div>{{ order.Country }}</div>
            <div>{{ order.Phone }}</div>
            <div>{{ order.Email }}</div>
          </div>
        </div>
      </tab>
    </tabs>
  </div>
</template>

<script>
import Tab from "@/components/elements/Tab.vue";
import { ApiFactory } from "@/api/ApiFactory.js";
import Tabs from "@/components/elements/Tabs.vue";
import OrderCustomerEditSlideover from "../components/slideovers/OrderCustomerEdit.vue";
import OrderAddressValidationStatus from "./OrderAddressValidationStatus.vue";

const OrderApi = ApiFactory.get("orders");

export default {
  name: "OrderCustomerInfo",
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data: () => {
    return {
      slideoverVisible: false,
      validating: false,
      validationStatus: -1,
      error: null,
    };
  },
  components: {
    Tabs,
    Tab,
    OrderCustomerEditSlideover,
    OrderAddressValidationStatus
  },
  computed: {
    canShowActions() {
      if (this.order.status?.Status === 'Unprocessed') {
        return false
      }
      return true;
    },
  },
  methods: {
    toggleSlideover() {
      this.slideoverVisible = !this.slideoverVisible;
    },
    validateAddress() {
      this.error = null;
      this.validationStatus = -1;
      this.validating = true;

      OrderApi.validateAddress(this.order.SourceOrderNumber, {type: "shipping"})
        .then(async (response) => {
          if (response.data.body.validated) {
            await OrderApi.validateStateRestriction(this.order.SourceOrderNumber, {params: {updateStatus: true}})
              .then((response) => {
                if (response.data.body.status === "Restricted") {
                  this.$router.go(0);
                }
              })
              .catch(e => this.error = e);
            this.validationStatus = 1;
            this.updateShippingInfo(response.data.body.order);
            this.$root.$emit('orderRefreshNotes');
          } else {
            this.validationStatus = 0;
          }

        })
        .catch(e => this.error = e)
        .finally(() => this.validating = false);
    },
    updateShippingInfo(order) {
      this.order = Object.assign(this.order, order);
    },
    address2(address) {
      if (address?.length > 40)
        return address.substring(1,37).trim() + '...';
      return address;
    },
  },
};
</script>

<style scoped></style>
